export default function PHP_filetype() {
  return (
    <div>
      <h1>PHP_filetype</h1>
    </div>
  );
}
